import axios from "axios";
import { getApiBaseURL } from "./apiBaseUrl";

export async function postTicketFlowAction({ token, action = "INIT", screen, data } = {}) {
  const { data: res } = await axios.post(
    `${getApiBaseURL()}/public/ticket-flow`,
    {
      token,
      action,
      screen,
      data: data && typeof data === "object" ? data : {},
    },
    { headers: { "Content-Type": "application/json" } }
  );
  return res?.data || res;
}
